import _ from 'lodash';
import React from 'react';

import {connect} from 'react-redux';
import {submit, isSubmitting, formValueSelector} from 'redux-form';

import {MODALS, fetchSendAgreementReminderDetails} from 'ducks/bookings';

import Button from 'components/Button';
import {default as Modal, withModal} from 'components/Modal';

import {SendAgreementReminderForm} from './components';

import './styles.css';

class SendAgreementReminderModal extends React.Component<any> {
  componentDidMount() {
    const {agreementId} = this.props.data;

    this.props.fetchSendAgreementReminderDetails(
      {agreement: agreementId},
      this.props.storeDataExtraActions(data => data)
    );
  }

  submitForm = () => this.props.submit('sendAgreementReminder');

  getExtraActions = () => {
    const {agreementId} = this.props.data;

    const refetchAgreementReminderDetails = () =>
      fetchSendAgreementReminderDetails(
        {agreement: agreementId},
        this.props.storeDataExtraActions(data => data)
      );

    return [
      ...this.props.closeModalExtraActions,
      refetchAgreementReminderDetails
    ];
  };

  render() {
    const {
      data: {signatures = [], agreementId},
      form: {submitting},
      anyAgreementUserCheckBoxIsSelected,
      closeModal
    } = this.props;
    const sendReminderButtonDisabled =
      submitting || !anyAgreementUserCheckBoxIsSelected;

    return (
      <Modal
        show={true}
        onClose={closeModal}
        type={Modal.MEDIUM}
        className="SendAgreementReminderModal">
        <Modal.Header heading="Send a Reminder" />
        <Modal.Body>
          <div className="heading">
            Which signers do you want to send a reminder to?
          </div>
          <SendAgreementReminderForm
            signatures={signatures}
            agreementId={agreementId}
            getExtraActions={this.getExtraActions}
          />
          <div className="noteContainer">
            <div className="label">PLEASE NOTE</div>
            <div className="message">
              HelloSign automatically sends a reminder to anyone who hasn't
              signed after 3 days and again after 7 days. You can disable these
              auto reminders by logging into HelloSign and visit the settings
              page.
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="SendReminderButton"
            onClick={this.submitForm}
            blue={!submitting}
            isLoading={submitting}
            disabled={sendReminderButtonDisabled}>
            Send Reminder
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const formSelector = formValueSelector('sendAgreementReminder');

const mapStateToProps = state => {
  const agreementUserCheckBoxesFormValues = [
    'primaryTenant',
    'secondaryTenant',
    'guarantor',
    'agent'
  ].map(el => formSelector(state, el));

  const anyAgreementUserCheckBoxIsSelected = _.some(
    agreementUserCheckBoxesFormValues
  );

  return {
    form: {
      submitting: isSubmitting('sendAgreementReminder')(state)
    },
    anyAgreementUserCheckBoxIsSelected
  };
};

const mapDispatchToProps = {
  submit,
  fetchSendAgreementReminderDetails
};

export default connect(mapStateToProps, mapDispatchToProps)(
  withModal(MODALS.SEND_AGREEMENT_REMINDER)(SendAgreementReminderModal)
);
